import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QueryOptions } from '@app/model/query-options';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { MessageService } from 'primeng/api';
import { Messages } from '@app/constants/constant';
import { TechnologyAddEditService} from '@app/technology-add-edit/technology-modal/technology-add.service';

@Component({
  selector: 'app-template-add-edit',
  templateUrl: './template-add-edit.component.html',
  styleUrls: ['./template-add-edit.component.css'],
  providers : [TechnologyAddEditService],  
})

export class TemplateAddEditComponent implements OnInit {
  technologyList : any;
  technology : any = {
    selectedTechnology :{
      id : '',
      name : '',
      isActive : false,
      hasTemplate : 1
    }  
  } ;
  evaluationData : any = {};
  display : boolean = false;
  isEditable : boolean = false;
  displayTemplate : boolean = false;
  isNew:boolean = false;
  techId:string;
  techName:string;
  oldTechId:string;
  fileToUpload: File | null = null;
  displayDialog: boolean = false;
  disableCreateButton : boolean = false;
  isPreview:boolean= false;
  editFlag:boolean = false;
  disableButton(item: boolean) {
    this.disableCreateButton = item;
    this.displayTemplate = !item;
    if(this.editFlag)
    {
      this.isPreview = item;
      this.displayTemplate = true;
    }
  }
  setEditFlag(item: boolean){
    this.editFlag = item;
  }

  constructor(
    private _api : TechnologyAddEditService,
    private _route : Router,
    private http: HttpClient,
    private _toastService: MessageService
  ) { }

  ngOnDestroy() {
    // ...
    localStorage.removeItem('techId');
    localStorage.removeItem('techName');
    localStorage.removeItem('technology');
    localStorage.removeItem('isNew');
    localStorage.removeItem('isPreview');
    localStorage.removeItem('displayTemplate');

  } 
  ngOnInit() {

     // isNew = undefined indicated Preview mode
     // isNew = false indicates New but template will be added using existing template
     // isNew = true indicates New and can be added via upload or manual entry.
    if(history && history.state && history.state.data){
      
      this.isNew = history.state.data.newFlag;
      this.isPreview =  history.state.data.disableFlag;
      this.displayTemplate = this.isPreview;
      if(history.state.data.technologyList){
        this.technologyList = history.state.data.technologyList;
        this.techId =  history.state.data.technology.selectedTechnology.id;
        this.techName = history.state.data.technology.selectedTechnology.name;

        window.localStorage.techId = this.techId;
        window.localStorage.techName = this.techName;
        if(this.isNew == true)
        {
          this.technology = history.state.data.technology;
          window.localStorage.technology = JSON.stringify(this.technology);
        }
        else{
          localStorage.removeItem('technology');
        }
      }
      window.localStorage.isNew = this.isNew != undefined ? this.isNew.toString() : undefined;
      window.localStorage.isPreview = this.isPreview.toString();
      window.localStorage.displayTemplate = this.isPreview.toString();
    }
    else{
      if(localStorage.isNew == undefined){
        this._route.navigate(['./technology-add-edit']); 
      }
      this.technologyList = this.getAllTechnologies();   
      this.techId = window.localStorage.techId;
      this.techName = window.localStorage.techName;
     
      this.isPreview = window.localStorage.isPreview == "true" ?true:false;
      this.isNew = window.localStorage.isNew == "true"?true:false;
      if(this.isNew == true)
      {
        this.technology = JSON.parse(window.localStorage.technology);
      }
      console.log(this.isNew);
      this.displayTemplate =  window.localStorage.displayTemplate == "true"?true:false;

    }
    if(this.isNew == false){
      this.filterTechnologies();
    }
  }

  getAllTechnologies() {
    this.technologyList = [];
    var params= this.queryParams("name", 1);
    this._api.getAllTechnologies(params).subscribe((res : any) => {
      let tech = res.map( item => {
          return {
            id : item.id,
            name : item.name,
            isActive : !item.deleted,
            hasTemplate: item.templateAvailable == 0 || item.templateAvailable == null ? false:true
          }
      });
      this.technologyList = tech;
     });
  }
  
  queryParams(sortFieldName?:string,sortOrder?:any){
      const queryParams = new Object();
      queryParams['sortParam'] = { sortField:sortFieldName , sortOrder: sortOrder };
      
      const tableSortingQueryOption = new QueryOptions(queryParams);
      tableSortingQueryOption.toQueryMap();
      return tableSortingQueryOption;
  }

  setTechnologyData = function (obj: any) {
    this.technology.selectedTechnology = {
      id : '',
      name : '',
      isActive : false,
      hasTemplate :1
    };
    if(this.technology.selectedTechnology && obj)
    {
      this.technology.selectedTechnology.name = obj.name;
      this.technology.selectedTechnology.id = obj.id;
      this.technology.selectedTechnology.isActive = obj.isActive;
      this.technology.selectedTechnology.hasTemplate = obj.hasTemplate;
    }
  
  }

  filterTechnologies() {
    let list2 =[];
    this.technologyList.forEach(element => {
      if(element.hasTemplate == 1){
        list2.push(element);
      }
    })
    this.technologyList = list2;
  }

  hideTemplate()
  {
    this.displayTemplate = false;
    this.disableCreateButton = false;
  }
  

  goToTemplate(){
    this.displayTemplate = true;
    this.disableCreateButton = true;
  }

  downloadSampleTemplate() {
    let header: any = ['Section', 'Group', 'Skills'];
    const csvArray = header.join(',');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = 'Template-Format.csv';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  showDialog() {
    this.displayDialog = true;
    
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  getApiCall(technologyId){
    this.http.get(environment.apiUrl+Messages.endpoint.candidate_evaluation_feedback+technologyId).toPromise().then(res=>{
        this.evaluationData = res;
  
    });
    }

  editTemplate(){
    this.disableCreateButton = true;
    this.isPreview = false;
    this.displayTemplate = true;
    this.editFlag = true;
    if(this.evaluationData.evaluationCategories == undefined)
    {
      this.getApiCall(this.techId);
    }
  }

  downloadTemplate(id) {
    let data :any =[];
    let skill:any;
    let skills:any =[];
    this.getApiCall(id);
    this.evaluationData.evaluationCategories.forEach(element => {
      element.evaluationSkills.forEach(item => {
        skill= item.skills.replace("<ul><li>", "").replace("</li></ul>", "");  
        skills = skill.split('</li><li>');
        skills.forEach(skillItem =>{
          data.push(
            {
              Section: element.name,
              Group: item.groups,
              Skills: skillItem
            });
          });
      });
    });
    
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    const csv = data.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );
    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    let file = this.isNew == undefined ? this.techName : this.technology.selectedTechnology.name;
    let fileName = file +'-Template.csv';
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();   
  }

  uploadFile() {
    if (this.fileToUpload) {
      const formData = new FormData();
      formData.append("file", this.fileToUpload, this.fileToUpload.name);
      formData.append("technologyId", this.techId);
      this.http
        .post(`${environment.apiUrl}/interview/upload-feedback`, formData).subscribe(res => {
          this.displayDialog = false;
          this.disableCreateButton = true;
          this.displayTemplate = false;
          this._toastService.add({ severity: 'success', summary: "File uploaded successfully.", detail: '' });
          this._route.navigate(['./technology-add-edit']); 
        },
          error => {
            this._toastService.add({ severity: 'error', summary: error, detail: '' });
          });
    }
  }
}
